<template>
  <v-container>
    <v-alert type="info"></v-alert>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      // Any data properties that might be needed for the iframe content
    };
  },
  methods: {
    // Any methods that might be needed for the iframe content
  },
  created() {
    // Any initialization logic needed when the iframe content loads
  }
};
</script>

<style scoped>
/* Add any relevant styles if needed */
</style>
